import useShouldItBeMounted from "@casino/legacy/shared/hooks/useShouldItBeMounted";
import SocialButtons from "./SocialButtons";
import useSocialLoginView from "./useSocialLoginView";

type Props = {
  connections: SocialConnection[];
};

const SocialAuthLoginView: FC<Props> = ({ connections }) => {
  const { otp } = useSocialLoginView();
  const shouldItBeMounted = useShouldItBeMounted();

  if (!shouldItBeMounted) {
    return null;
  }

  return <SocialButtons connections={connections} otp={otp} />;
};

export default SocialAuthLoginView;
